import * as React from 'react';

function SvgIconReconciliation(props) {
  return (
    <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.571 0C15.361 0 16 .64 16 1.429V14.57c0 .79-.64 1.429-1.429 1.429H1.43C.639 16 0 15.36 0 14.571V1.43C0 .639.64 0 1.429 0H14.57zM12 10.286H4.343a.571.571 0 000 1.143H12a.571.571 0 100-1.143zm0-2.857H4.343a.571.571 0 100 1.142H12a.571.571 0 100-1.142zm0-2.858H4.343a.571.571 0 000 1.143H12a.571.571 0 100-1.143z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgIconReconciliation;
